import React, { useEffect, useState } from 'react';
import { useUser } from '../context/UserContext';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useUser();
  const { showLoginModal, showRegisterModal } = useAuth();
  const [shouldShowLogin, setShouldShowLogin] = useState(false);

  useEffect(() => {
    let timer;
    if (!loading && !user) {
      // 延迟500ms显示登录框，避免闪烁
      timer = setTimeout(() => {
        setShouldShowLogin(true);
      }, 500);
    } else {
      setShouldShowLogin(false);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [loading, user]);

  useEffect(() => {
    if (shouldShowLogin) {
      showLoginModal();
      
      // 自定义处理注册链接点击事件
      const handleRegisterLinkClick = (e) => {
        const target = e.target;
        // 检查是否点击了"注册账号"按钮
        if (target.tagName === 'BUTTON' && target.textContent === '注册账号') {
          e.preventDefault();
          e.stopPropagation();
          showRegisterModal();
        }
      };

      // 添加事件监听器
      document.addEventListener('click', handleRegisterLinkClick, true);

      // 清理函数
      return () => {
        document.removeEventListener('click', handleRegisterLinkClick, true);
      };
    }
  }, [shouldShowLogin, showLoginModal, showRegisterModal]);

  // 如果正在加载用户信息，显示空内容
  if (loading) {
    return null;
  }

  // 如果用户未登录，显示空内容（登录弹窗会由useEffect触发）
  if (!user) {
    return null;
  }

  // 如果用户已登录，显示受保护的路由内容
  return children;
};

export default PrivateRoute; 